import { DeleteOutlined } from '@ant-design/icons';
import { Button } from '@components/Button/Button';
import { memo } from 'react';

import { canFarmAction } from '../FarmingTable/FarmingTable';
import cl from './styles.module.scss';

interface FarmingCommonTitleProps {
  title: number;
  onDelete: () => void;
  canAction: canFarmAction;
}

export const FarmingCommonTitle = memo(
  ({ title, onDelete, canAction }: FarmingCommonTitleProps) => {
    return (
      <div className={cl.wrap}>
        <span className={cl.title}>{title}</span>
        <Button
          type="text"
          action={onDelete}
          icon={<DeleteOutlined style={{ fontSize: '14px' }} />}
          display={canAction.editRow}
        />
      </div>
    );
  },
);
